<template>
  <div>
    <el-row v-if="userCard" v-loading="loading" :gutter="24">
      <el-col :xs="24">
        <div class="card">

          <el-radio-group
              class="tab-tags"
              v-model="currentTab"
              size="mini"
              @change="changeRadio"
          >
            <el-radio-button
                key="new"
                :label="{}"
            >+ добавить абонемент
            </el-radio-button>
            <el-radio-button
                v-for="tag in subscriptions"
                :key="tag.id"
                :label="tag"
            >{{ tag.title }}
            </el-radio-button>

          </el-radio-group>
          <div class="card__show-all" @click="showAll">Посмотреть архивные...</div>

          <subscription-table
              v-if="currentTab"
              @update="loadData"
              :user="user"
              :subscription="currentTab"/>

        </div>
      </el-col>
    </el-row>

    <all-subscription
        :user="user"
        :visible="isVisibleAllSubscription"
        @close="isVisibleAllSubscription = false"/>

    <new-subscription
        :visible="isVisibleNewSubscription"
        :user="user"
        @update="loadData"

        :subscription="subscriptions[1]"
        @close="isVisibleNewSubscription = false"/>

  </div>
</template>

<script>
import {mapGetters} from "vuex"

import AllSubscription from "@/components/dialog/AllSubscription.vue"
import NewSubscription from "@/components/dialog/NewSubscription.vue"
import SubscriptionTable from "@/components/elements/UserSubscription/SubscriptionTable.vue"

export default {
  name: "UserSubscription",
  components: {AllSubscription, NewSubscription, SubscriptionTable},
  props: {
    user: {
      required: true
    }
  },
  data: () => {
    return {
      loading: false,
      userCard: {},
      isVisibleAllSubscription: false,
      currentTab: null,
      subscriptions: [],

      isVisibleNewSubscription: false
    }
  },
  computed: {
    ...mapGetters("session", {
          department: "department"
        }
    ),
  },
  mounted() {
    this.loadData()
  },
  methods: {
    changeRadio(value) {
      if ((Object.keys(value).length == 0)) {
        this.currentTab = null
        this.isVisibleNewSubscription = true
      }

    },
    openUser() {
      this.$emit("openUser", this.user)
    },
    showAll() {
      this.isVisibleAllSubscription = true
    },
    // loadMembership
    loadData() {
      this.loading = true
      this.$api.membership.getList(this.user.id).then((response) => {
        this.subscriptions = response.data

          this.currentTab = response.data[0]
        this.$forceUpdate()
      }).catch(res => {

        this.$notify.error({
          title: "Ошибка загрузки абонементов",
          message: res.response.data.message,
        })

      }).finally(() => {
        this.loading = false
      })

    },
    close() {


    },
  },

}
</script>

<style scoped lang="scss">
.card {

  &__balance {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 41px;

    color: #111;
  }

  &__date {
    margin: 2px 0 24px 0;

    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;

    color: #8E8E93;
  }

  &__title {

    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    color: #111;
  }

  &__show-all {
    margin-top: 12px;
    cursor: pointer;

    font-size: 11px;
    line-height: 13px;
    color: #078065;

    &:hover {
      opacity: .8;
    }

  }

  &__subtitle {
    margin-top: 4px;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    color: #111;
  }

  &__description {
    margin-top: 5px;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;

    color: #111;

    &_red {
      color: #FF6464;
    }
  }

}

.tab-tags {
  margin: 8px 48px 8px 48px;
}

.tab-item {
  margin-top: 16px;

}

/deep/ .el-tabs__header {
  display: none;
}


</style>
